import { Button, DataTable, FlexLayout, Icon } from '@deity-io/portal-ui';
import { ConfirmationModal, EntityTableDivider } from 'components';
import { APOLLO_BASE_OPTIONS, toLocalDateString } from 'contracts/constants';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import {
  GetMockDataByPackageVersionDocument,
  useDeleteMockDataMutation,
  useGetMockDataByPackageVersionLazyQuery
} from 'services/graphql/generated/hooks';

interface EntityMockDataProps {
  locked?: boolean;
  packageVersionUuid: string;
  modelUuid?: string;
  endpointUuid?: string;
  mappingUuid?: string;
  onSelect?: (uuid: string) => void;
}
const EntityMockData: FC<EntityMockDataProps> = ({
  locked = false,
  packageVersionUuid,
  modelUuid,
  endpointUuid,
  mappingUuid,
  onSelect
}) => {
  // const { url } = useRouteMatch();
  const [pageSize, setPageSize] = useState(25);
  const [modalOpen, setModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [mappingToDelete, setMappingToDelete] = useState<any>();
  // const { pathname } = useLocation();
  // const params: any = getParams(pathname, [ENTITY_PATH_ID, ENTITY_PATH]);
  const [getMockData, { loading, data: mockData, fetchMore, refetch }] =
    useGetMockDataByPackageVersionLazyQuery(APOLLO_BASE_OPTIONS);

  const [deleteMockData] = useDeleteMockDataMutation({
    refetchQueries: [
      {
        query: GetMockDataByPackageVersionDocument,
        variables: {
          offset: 0,
          limit: pageSize,
          packageVersionUuid,
          modelUuid
        }
      }
    ]
  });

  const totalItems = mockData?.getMockDataByPackageVersion?.totalItems;
  const data = mockData?.getMockDataByPackageVersion?.data;

  useEffect(() => {
    if (packageVersionUuid) {
      getMockData({
        variables: {
          offset: 0,
          limit: pageSize,
          packageVersionUuid,
          modelUuid
        }
      });
    }
  }, [packageVersionUuid, modelUuid]);

  const loadNewMapping = () => {
    setModalOpen(false);
    if (packageVersionUuid && fetchMore && mockData) {
      fetchMore({
        variables: {
          packageVersionUuid,
          offset: 0,
          limit: (mockData?.getMockDataByPackageVersion?.data.length || 0) + 1
        }
      });
    }
  };

  const onLoadMore = () => {
    if (fetchMore && mockData) {
      fetchMore({
        variables: {
          packageVersionUuid,
          offset: mockData?.getMockDataByPackageVersion?.data.length,
          limit: pageSize
        }
      });
    }
  };

  return (
    <>
      <DataTable
        data={data || []}
        columns={[
          {
            key: 'name',
            name: 'Name',
            // eslint-disable-next-line react/no-unstable-nested-components
            formatter: ({ value }) => <b>{value}</b>,
            align: 'right'
          },
          // {
          //   key: 'name',
          //   name: 'STATUS',
          //   formatter: ({ value }) => (
          //     <MappingStatusBadge packageVersionUuid={params?.versionUuid} schema={value.schema} />
          //   ),
          //   align: 'right'
          // },
          {
            key: '',
            name: '',
            // eslint-disable-next-line react/no-unstable-nested-components
            formatter: () => <EntityTableDivider />
          },
          {
            key: 'modifiedAt',
            name: 'LAST MODIFIED',
            formatter: ({ value }) => toLocalDateString(value)
          },
          {
            key: 'uuid',
            name: '',
            align: 'center',
            isActionCell: true,
            // eslint-disable-next-line react/no-unstable-nested-components
            formatter: ({ value }) => (
              <FlexLayout>
                {!locked && (
                  <Button
                    endIcon={<Icon icon="delete" color="error" />}
                    onClick={() => {
                      setMappingToDelete(value);
                      setIsDeleteModalOpen(true);
                    }}
                  />
                )}
              </FlexLayout>
            )
          }
        ]}
        pageSize={pageSize}
        onPageSizeChange={setPageSize}
        totalResults={totalItems || pageSize}
        showPagination
        onPageChange={() => onLoadMore()}
        onRowClick={endpoint => {
          if (onSelect) {
            onSelect(endpoint.uuid);
          }
        }}
        noResultsMsg="No mock data saved"
        fullClickable
        isLoading={loading}
      />

      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        setIsOpen={setIsDeleteModalOpen}
        entityType="test data"
        entityUuid={mappingToDelete}
        onConfirm={uuid => {
          deleteMockData({ variables: { packageVersionUuid, uuid: uuid! } }).catch(err => {
            // eslint-disable-next-line no-alert
            alert(`Failed to delete mock data. ${err}`);
          });
        }}
      />
    </>
  );
};

export default EntityMockData;
